import { render, staticRenderFns } from "./riskWarning.vue?vue&type=template&id=1fff6ba7&scoped=true"
import script from "./riskWarning.vue?vue&type=script&lang=js"
export * from "./riskWarning.vue?vue&type=script&lang=js"
import style0 from "./riskWarning.vue?vue&type=style&index=0&id=1fff6ba7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff6ba7",
  null
  
)

export default component.exports